<div>
    <h2 mat-dialog-title>Edit Municipality</h2>
    <mat-dialog-content>
        <form fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="10px" [formGroup]="municipalityForm">
            <phone-input label="Fire Phone" [theForm]="municipalityForm" field="firePhone"></phone-input>
            <phone-input label="Police Phone" [theForm]="municipalityForm" field="policePhone"></phone-input>
            <phone-input label="Auxiliary Phone" [theForm]="municipalityForm" field="auxiliaryPhone"></phone-input>
        </form>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
        <a mat-stroked-button id="cancel" (click)="cancel.emit()">Cancel</a>
        <button mat-raised-button color="primary" class="new-primary-button" (click)="saveAction()" type="button">Save</button>
    </mat-dialog-actions>
</div>
